import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateSampleCollectionSlice, getSampleCollectionListSlice, } from "../../../store/slices/sampleCollectionSlice";
const SampleCollectionEditModal = ({
  show,
  handleClose,
  sampleData,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId = clinicInfo?.[0]?.clinicId;
  const [formData, setFormData] = useState({});
  const formatDateTime = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().slice(0, 16);
  };
  useEffect(() => {
    if (sampleData) {
      setFormData({
        ...sampleData,
        collectedDate: formatDateTime(sampleData.collectedDate),
        discardAt: formatDateTime(sampleData.discardAt),
        receivedAt: formatDateTime(sampleData.receivedAt),
      });
    }
  }, [sampleData]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async () => {
    if (!clinicId || !token) return;
    await dispatch(
      updateSampleCollectionSlice({
        appointmentId: sampleData.appointmentObjectId,
        status: formData.status,
        collectedBy: formData.collectedBy,
        collectedDate: formData.collectedDate,
        discardStatus: formData.discardStatus,
        discardAt: formData.discardAt,
        sampleAge: formData.sampleAge,
        sampleViaType: formData.sampleViaType,
        sampleViaNote: formData.sampleViaNote,
        receivedAt: formData.receivedAt,
        clinicId,
        token,
      })
    );
    dispatch(
      getSampleCollectionListSlice({
        clinicId,
        token,
      })
    );
    handleClose();
  };
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Sample Collection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Patient Name</label>
            <input
              className="form-control"
              value={formData.patientName || ""}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>UHID</label>
            <input
              className="form-control"
              value={formData.uhid || ""}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Age</label>
            <input
              className="form-control"
              value={formData.patientAge?.year || ""}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Appointment ID</label>
            <input
              className="form-control"
              value={formData.appointmentId || ""}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Appointment Date</label>
            <input
              className="form-control"
              value={
                formData.appointmentDate
                  ? new Date(formData.appointmentDate)
                    .toISOString()
                    .split("T")[0]
                  : ""
              }
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Service</label>
            <input
              className="form-control"
              value={formData.service || ""}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Service Mode</label>
            <input
              className="form-control"
              value={formData.serviceMode || ""}
              disabled
            />
          </div>
          <div className="col-md-12 mb-3">
            <label>Service Details</label>
            <input
              className="form-control"
              value={formData.serviceDetails?.join(", ") || ""}
              disabled
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Status</label>
            <select
              name="status"
              value={formData.status || ""}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">Select</option>
              <option>Not Collected</option>
              <option>Collected</option>
              <option>Rejected</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label>Collected By</label>
            <input
              name="collectedBy"
              value={formData.collectedBy || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Collected Date</label>
            <input
              type="datetime-local"
              name="collectedDate"
              value={formData.collectedDate || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Discard Status</label>
            <select
              name="discardStatus"
              value={formData.discardStatus || ""}
              onChange={handleChange}
              className="form-control"
            >
              <option>Pending</option>
              <option>Discard</option>
              <option>Not Collected</option>
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label>Discard At</label>
            <input
              type="datetime-local"
              name="discardAt"
              value={formData.discardAt || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Sample Age</label>
            <input
              name="sampleAge"
              value={formData.sampleAge || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Sample Via Type</label>
            <input
              name="sampleViaType"
              value={formData.sampleViaType || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Sample Via Note</label>
            <input
              name="sampleViaNote"
              value={formData.sampleViaNote || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Received At</label>
            <input
              type="datetime-local"
              name="receivedAt"
              value={formData.receivedAt || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={handleSubmit}>Update</button>
      </Modal.Footer>
    </Modal>
  );
};
export default SampleCollectionEditModal;